export const convertArrayToRows = (array, itemsPerRow) => {
    const rows = [];
    for (let i = 0; i < array.length; i += itemsPerRow) {
        rows.push(array.slice(i, i + itemsPerRow));
    }
    return rows;
}